/**
 * expert-popup.js  |  assets/expert-popup.js
 * <script src="{{ 'expert-popup.js' | asset_url }}" defer></script>
 *
 * MOBILE  (< 768px)
 *   - Tap "Reviewed by Our Expert" → open popup (centred overlay + backdrop)
 *   - Tap backdrop or anywhere outside popup → close
 *
 * DESKTOP (≥ 768px)
 *   - Hover expert avatar → open popup (floats right)
 *   - Mouse leaves trigger AND popup (200ms grace) → close
 *   - Click "Reviewed by Our Expert" label → open expert page in new tab
 *   - Click avatar / name / "Read more" → open expert page in new tab
 *   - Click LinkedIn / Instagram icons → open respective profile in new tab
 */

(function () {
  'use strict';

  var BREAKPOINT = 768;

  function isMobile() {
    return window.innerWidth < BREAKPOINT;
  }

  var wrap     = document.getElementById('expert-review-wrap');
  if (!wrap) return;

  var trigger  = document.getElementById('expert-trigger');
  var popup    = document.getElementById('expert-popup');
  var bio      = document.getElementById('expert-bio-text');
  var readMore = document.getElementById('expert-read-more');

  if (!trigger || !popup) return;

  /* No backdrop element needed — document click handles closing */

  var hideTimer = null;

  /* ══ OPEN / CLOSE ═══════════════════════════════════════════════════════ */
  function openPopup() {
    clearTimeout(hideTimer);
    popup.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closePopup() {
    popup.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
  }


  /* ══ MOBILE BEHAVIOURS ══════════════════════════════════════════════════ */

  /* Tap trigger → toggle popup */
  trigger.addEventListener('click', function (e) {
    if (!isMobile()) return;
    e.stopPropagation();
    popup.classList.contains('is-open') ? closePopup() : openPopup();
  });

  /* Prevent any tap inside popup from bubbling to document */
  popup.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  /* Tap outside both trigger and popup → close */
  document.addEventListener('click', function (e) {
    if (!isMobile()) return;
    if (!wrap.contains(e.target) && !popup.contains(e.target)) {
      closePopup();
    }
  });

  /* ══ DESKTOP BEHAVIOURS ═════════════════════════════════════════════════ */

  /* Hover avatar image ONLY → open popup */
  var avatarImg = trigger.querySelector('.expert-review__trigger-avatar');
  if (avatarImg) {
    avatarImg.addEventListener('mouseenter', function () {
      if (isMobile()) return;
      openPopup();
    });
  }

  /* Click anywhere outside on desktop → close (popup never auto-closes on mouseleave) */
  document.addEventListener('click', function (e) {
    if (isMobile()) return;
    if (!wrap.contains(e.target) && !popup.contains(e.target)) {
      closePopup();
    }
  });

  /* Desktop: clicking "Reviewed by Our Expert" label → opens expert page in new tab */
  var label = trigger.querySelector('.expert-review__trigger-label');
  if (label) {
    label.addEventListener('click', function (e) {
      if (isMobile()) return;
      e.stopPropagation();
      var nameLink = popup.querySelector('.expert-popup__name');
      if (nameLink && nameLink.href) {
        window.open(nameLink.href, '_blank', 'noopener');
      }
    });
  }

  /* ══ KEYBOARD ACCESSIBILITY ═════════════════════════════════════════════ */
  trigger.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      popup.classList.contains('is-open') ? closePopup() : openPopup();
    }
    if (e.key === 'Escape') closePopup();
  });

  popup.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closePopup();
      trigger.focus();
    }
  });

  /* ══ READ MORE → redirects to expert page (new tab) ════════════════════ */
  if (readMore) {
    readMore.addEventListener('click', function (e) {
      e.stopPropagation();
      var nameLink = popup.querySelector('.expert-popup__name');
      if (nameLink && nameLink.href) {
        window.open(nameLink.href, '_blank', 'noopener');
      }
    });
  }

})();